import React, { useEffect, useRef, useState } from 'react';
import { Tooltip } from '@mui/material';
import Popover from 'components/library/Popover';
import { useDebounceCallback } from '@react-hook/debounce';
import strings from 'constants/localization';
import Icon, { ICON_TYPES } from 'components/library/Icon';
import useEditorData from '../../../../../../components/Editor/hooks/useEditorData';
import SidebarButton from '../../../components/SidebarButton';
import SidebarSlider from '../../../components/SidebarSlider';
import css from './TextSpacing.module.css';

const sliderProps = {
  min: 0,
  max: 20,
};

const CodeMargin:React.FC = () => {
  const [popoverState, setPopoverState] = useState<boolean>(false);
  const ref = useRef<HTMLButtonElement>(null);

  const {
    canvas,
    activeObject,
  } = useEditorData();

  const [value, setValue] = useState<number>(activeObject.margin);

  useEffect(() => handleChange(value), [value]);

  // update value, when activeObject changed
  useEffect(() => setValue(activeObject.margin), [activeObject.margin]);

  const handleChange = useDebounceCallback(async (newValue: number) => {
    if (!canvas.current || activeObject.margin === newValue) {
      return;
    }

    activeObject.set({ margin: newValue });
    await activeObject.generate();
    canvas.current.fire('object:modified', { target: activeObject });
  }, 500);

  return (
    <>
      <Tooltip placement="top" title={strings.editorTabSettingsCodeMarginTooltip} arrow>
        <SidebarButton
          ref={ref}
          isActive={popoverState}
          onClick={() => setPopoverState(!popoverState)}
        >
          <Icon type={ICON_TYPES.borderSize} />
        </SidebarButton>
      </Tooltip>
      <Popover
        open={popoverState}
        anchorEl={ref.current}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={() => setPopoverState(false)}
        PaperProps={{ className: css.paper }}
      >
        <SidebarSlider
          onChange={setValue}
          value={value}
          withInput
          {...sliderProps}
        />
      </Popover>
    </>
  );
};

export default CodeMargin;
